import { openbetHttpClient } from "@/api/openbet-http-client";
import { SazkaEventsDrilldownList, SazkaEventsDrilldownListParams } from "./interfaces/sazka-events-drilldown-list";
import { SazkaTrendingEventsDrilldownList } from "@/api/interfaces/sazka-trending-events-drilldown-list";
import {
    SazkaEventsDrilldownDetail,
    SazkaEventsDrilldownDetailParams,
} from "@/api/interfaces/sazka-events-drilldown-detail";
import { SazkaDetailedSearch, SazkaDetailedSearchParams } from "@/api/interfaces/sazka-detailed-search";
import { appendEnvSuffix } from "@/api/http-client-helpers";
import type { SlipBuild, SlipBuildData, SlipBuildParams } from "@/api/interfaces/slip-build";
import { isEqual as _isEqual } from "lodash";
import { logException } from "@/shared/utils/logger/use-app-logger";

const path = appendEnvSuffix("/orchestrations");

export async function getSazkaEventsDrilldownList(params: SazkaEventsDrilldownListParams) {
    const response = await openbetHttpClient.get<SazkaEventsDrilldownList>(`${path}/sazkaEventsDrilldownList`, {
        params,
    });
    return response?.data;
}

export async function getSazkaTrendingEventsDrilldownList() {
    // TODO rozsirit groupovani  marketu na BE na trendingEvents.
    const response = await openbetHttpClient.get<SazkaTrendingEventsDrilldownList>(`${path}/sazkaTrendingEvents`);
    return response?.data;
}

export async function getSazkaEventsDrilldownDetail(params: SazkaEventsDrilldownDetailParams) {
    const response = await openbetHttpClient.get<SazkaEventsDrilldownDetail>(`${path}/sazkaEventsDrilldownDetail`, {
        params,
    });
    return response?.data;
}

export async function getSazkaDetailedSearch(params: SazkaDetailedSearchParams) {
    const response = await openbetHttpClient.get<SazkaDetailedSearch>(`${path}/sazkaDetailedSearch`, {
        params,
    });
    return response?.data?.data;
}

export async function postSazkaBuildSlip(data: SlipBuildData, params?: SlipBuildParams) {
    try {
        const response = await openbetHttpClient.post<SlipBuild>(`${path}/buildSlip`, data, { params });
        return response.data;
    } catch (error) {
        // TODO: Not 100% sure yet whether we want to bubble all error data... will crystallize later during usage
        //  Btw... this is totally stupid approach by the ep to return error states of the slip as http errors because we'll need to catch all those errors here
        //  Allow only known errors like 422 to be able to return data as SlipBuild and log the rest (maybe ignore in the future)
        if ([422].includes(error.response.status)) {
            return error.response.data as SlipBuild;
        } else if (_isEqual(error.response.data.data, { status: "BUILD_ERROR" })) {
            logException("orchestrations-api", error, {
                message: "An error has occurred while posting build slip (don't confuse with slip build or slip bet)",
                data: data,
                params: params,
            });
        } else if (
            _isEqual(error.response.data.data, {
                status: 500,
                error: "java.net.SocketException",
                message: "Connection reset",
            })
        ) {
            logException("orchestrations-api", error, {
                message:
                    "Connection reset error occurred while posting build slip (don't confuse with slip build slip bet)",
                data: data,
                params: params,
            });
        }
    }
}
